export class SignedVacations {
  documentId!: string;
  year!: string;
}
